<template>
    <teleport to="#modal">
        <Loading
            :visible="loading"
        >
        </Loading>
        <ModalProgetto @saved="onUpdateProgetto" :create="false" :id="id" v-model:visible="visible"></ModalProgetto>
        <ModalSottoProgetto
            :defaultValue="sottoprogettoDefaultValue"
            @saved="onAddSottoProgetto"
            :progetto_id="id"
            :progetto_is_promo="progetto_model.promo"
            @chiudi="sp_visible = false"
            :cliente_id="progetto_model.cliente_id"
            v-model:visible="sp_visible"></ModalSottoProgetto>
    </teleport>
    <!--    <div class="flex justify-between">-->

    <!--    </div>-->
    <div class="m-auto px-8 md:px-20 pb-8">
        <div class="max-w-screen-2xl m-auto">
            <div class="py-10 flex justify-between items-center">
                <Breadcrumbs :paths="getBreadcrumbsPath"></Breadcrumbs>
                <div class="flex">
                    <NextButton @click="visible=true" variant="outline-secondary" class="w-44 text-sm py-2 px-4">
                        Modifica
                    </NextButton>
                </div>
            </div>
            <div class="flex justify-between items-baseline my-5">
                <span class="text-2xl"><b>{{ progetto_model.titolo }}</b></span>
                <span class="text-xl"><b>ID PROGETTO: {{ progetto_model.id_gamma }}</b></span>
            </div>
            <div class="grid md:grid-cols-2 xl:grid-cols-4 gap-3 overflow-x-auto">
                <CardDivisorioGrigio>
                    <template v-slot:top>
                        <div class="text-sm"><b>Denominazione cliente</b></div>
                    </template>
                    <template v-slot:bottom>
                        <router-link :to="{name:'DettaglioAzienda', params:{id:azienda_progetto?.id}}"
                            class="text-next-stato-7 dark:text-next-stato-6 hover:underline"
                        >
                            {{ azienda_progetto?.denominazione || '-' }}
                        </router-link>
                    </template>
                </CardDivisorioGrigio>
                <CardDivisorioGrigio>
                    <template v-slot:top>
                        <div class="text-sm"><b>Ragione sociale cliente</b></div>
                    </template>
                    <template v-slot:bottom>
                        <div>{{ azienda_progetto?.ragione_sociale || '-' }}</div>
                    </template>
                </CardDivisorioGrigio>
                <CardDivisorioGrigio>
                    <template v-slot:top>
                        <div class="text-sm"><b>Committente</b></div>
                    </template>
                    <template v-slot:bottom>
                        <div>{{ committente_progetto?.ragione_sociale || '-' }}</div>
                    </template>
                </CardDivisorioGrigio>
                <CardDivisorioGrigio>
                    <template v-slot:top>
                        <div class="text-sm"><b>Azienda</b></div>
                    </template>
                    <template v-slot:bottom>
                        {{ azienda_gruppo?.nome }}
<!--                        <div class="grid gap-2 w-full"-->
<!--                             :style="{'grid-template-columns': `repeat(${bu.length}, minmax(0, 1fr))`}">-->
<!--                            <div v-for="b in bu" :key="b.id" class="border rounded text-center text-xs px-1"-->
<!--                                 :class="[b.owned ? 'border-next-orange text-next-orange':'text-next-neu']">{{-->
<!--                                    b.label-->
<!--                                }}-->
<!--                            </div>-->
<!--                        </div>-->
                    </template>
                </CardDivisorioGrigio>
                <CardDivisorioGrigio>
                    <template v-slot:top>
                        <div class="text-sm"><b>Data di inizio</b></div>
                    </template>
                    <template v-slot:bottom>
                        <div>{{ progetto_model.data_inizio ? $filters.toDate(progetto_model.data_inizio) : '-' }}</div>
                    </template>
                </CardDivisorioGrigio>
                <CardDivisorioGrigio>
                    <template v-slot:top>
                        <div class="text-sm"><b>Data di fine</b></div>
                    </template>
                    <template v-slot:bottom>
                        <div>{{ progetto_model.data_fine ? $filters.toDate(progetto_model.data_fine) : '-' }}</div>
                    </template>
                </CardDivisorioGrigio>
                <CardDivisorioGrigio>
                    <template v-slot:top>
                        <div class="text-sm"><b>Budget di apertura</b></div>
                    </template>
                    <template v-slot:bottom>
                        <div>{{ progetto_model.budget ? $filters.toEuroCurrency(progetto_model.budget) : '-' }}</div>
                    </template>
                </CardDivisorioGrigio>
                <CardDivisorioGrigio>
                    <template v-slot:top>
                        <div class="text-sm"><b>Budget preventivo</b></div>
                    </template>
                    <template v-slot:bottom>
                        <div>{{
                                progetto_model.budgetConsuntivo ? $filters.toEuroCurrency(progetto_model.budgetConsuntivo) : '-'
                            }}
                        </div>
                    </template>
                </CardDivisorioGrigio>
            </div>
            <div class="flex justify-between items-center mt-7 mb-3">
                <span class="text-xl">Sottoprogetti</span>
                <div class="flex">
                    <NextButton variant="primary" @click="sp_visible=true"
                                class="w-44 text-sm py-2 px-4">
                        + Aggiungi
                    </NextButton>
                </div>
            </div>
            <div class="rotate-x-180 overflow-x-scroll">
                <NextTable class="rotate-x-180 w-full border-separate border-spacing-3 py-4 table-fixed"
                           v-model:cols="sottoProgettiCols"
                           :rows="listaSottoprogettiProgetto.rows"
                           @order-update="listaSottoprogettiProgetto.updateCols">
                    <template v-for="(c, j) in listaSottoprogettiProgetto.rows" :key="j" v-slot:[`td_${j}_2`]="context">
                        {{ bu.find(el=>el.id == c.business_unit_id)?.label }}
                    </template>
                    <template v-for="(c, j) in listaSottoprogettiProgetto.rows" :key="j" v-slot:[`td_${j}_3`]="context">
                        {{ $filters.toDate(context.context.row.data_inizio) }}
                    </template>
                    <template v-for="(c, j) in listaSottoprogettiProgetto.rows" :key="j" v-slot:[`td_${j}_4`]="context">
                        {{ $filters.toDate(context.context.row.data_fine) }}
                    </template>
                    <template v-for="(c, j) in listaSottoprogettiProgetto.rows" :key="j" v-slot:[`td_${j}_5`]="context">
                        {{ $filters.toEuroCurrency(context.context.row.budget) }}
                    </template>
                    <template v-for="(c, j) in listaSottoprogettiProgetto.rows" :key="j" v-slot:[`td_${j}_6`]="context">
                        {{ context.context.row.stato_next_descrizione }}
                    </template>
                    <template v-for="(c, j) in listaSottoprogettiProgetto.rows" :key="j" v-slot:[`td_${j}_7`]="context">
                        <router-link :to="{name:'DettaglioSottoProgetto', params:{id:context.context.row.id}}"
                                     class="text-center inset-0 absolute flex items-center justify-center"><i
                            class="icon-chevron_destra"></i></router-link>
                    </template>
                </NextTable>
            </div>

            <InfiniteLoading @infinite="listaSottoprogettiProgetto.fetchNextPage"
                             :identifier="listaSottoprogettiProgetto.infiniteIdentifier"
                             style="min-height: 1px">
                <template #complete>
                    <div class="text-center pb-3">Non ci sono altri sottoprogetti.</div>
                </template>
            </InfiniteLoading>
        </div>
    </div>
</template>

<script lang="ts">
import {Options, Vue, setup} from 'vue-class-component';
import Topbar from "../components/Topbar.vue";
import NextTable from "@/components/NextTable.vue";
import ContextMenu from "@/components/ContextMenu.vue";
import Loading from "@/components/Loading.vue";
import InfiniteLoading from "v3-infinite-loading";
import progettiManager from "../api/Progetti";
import ModalProgetto from "@/components/ModalProgetto.vue";
import ModalSottoProgetto from "@/components/ModalSottoProgetto.vue";
import businessUnitsManager from "../api/BusinessUnits";
import NextButton from "@/components/NextButton.vue";
import CardDivisorioGrigio from "@/components/CardDivisorioGrigio.vue";
import Breadcrumbs from "@/components/Breadcrumbs.vue";
import {Paths} from "@/types";
import {dettaglio_progetto} from "@/BreadcrumbsPath";
import clientiManager from "../api/Clienti";
import ContextMenuOpener from "@/setup/ContextMenuOpener";
import TabellaContextMenu from "@/components/TabellaContextMenu.vue";
import moment from 'moment';
import Lista from "@/setup/ListaCerca";
import {aziendeGruppoManager} from "../api/AziendeGruppo";

@Options({
    name: 'DettaglioProgetto',
    components: {
        InfiniteLoading,
        Breadcrumbs,
        CardDivisorioGrigio,
        NextButton,
        Topbar,
        Loading,
        NextTable,
        ContextMenu,
        ModalProgetto,
        TabellaContextMenu,
        ModalSottoProgetto
    },
    props: {
        id: String,
    }
})
export default class DettaglioProgetto extends Vue {
    cmOpener: any = setup(() => ContextMenuOpener())
    id!: number | string
    loading = false
    visible = false
    sp_visible = false
    cm_visible = -1
    azienda_gruppo = null

    listaSottoprogettiProgetto: any = setup(() => Lista(progettiManager, this.sottoProgettiCols, progettiManager.sottoprogetti))

    progetto_model: any = {
        id: 0,
        budgetPreventivo: 0.0,
        titolo: null,
        cliente_id: null,
        stato: null,
        budget: 0,
        budgetConsuntivo: 0.0,
        data_inizio: null,
        data_fine: null,
    }

    azienda_progetto = null
    committente_progetto = null

    sottoprogettoDefaultValue: any = {}

    bu = []

    sottoProgettiRows: any[] = []

    // sortSottoProgetti = ''

    get getBreadcrumbsPath(): Paths[] {
        return dettaglio_progetto
    }

    updateColsSottoProgetti() {
    }

    onUpdateProgetto(data: any) {
        this.progetto_model = {...this.progetto_model, ...data}
        this.visible = false
    }

    onAddSottoProgetto() {
        this.sp_visible = false
        this.reload()
    }

    created() {
        this.listaSottoprogettiProgetto.callBinds = [this.id]
        this.reload()
    }

    reload() {
        const promises: any[] = []
        this.loading = true
        promises.push(progettiManager.progetto(this.id).then((response) => {
            this.progetto_model = response.data

            aziendeGruppoManager.retrieve(this.progetto_model.azienda_gruppo_id).then((response)=>{
                this.azienda_gruppo = response.data
            })

            businessUnitsManager.businessUnits({params:{crm: 1}}).then((res) => {
                this.bu = res.data.map((bu: any) => {
                    return {...bu, owned: this.progetto_model.owned_bu.indexOf(bu.id) >= 0}
                })
            })

            clientiManager.cliente(this.progetto_model.cliente_id).then((response) => {
                this.azienda_progetto = response.data
            })
            clientiManager.cliente(this.progetto_model.committente_id).then((response) => {
                this.committente_progetto = response.data
            })
        }))

        Promise.all(promises).finally(() => {
            this.listaSottoprogettiProgetto.reset()
            this.setSottoprogettoDefaultValue()
            this.loading = false
        })
    }

    setSottoprogettoDefaultValue() {
        this.sottoprogettoDefaultValue.titolo = this.progetto_model.titolo
        this.sottoprogettoDefaultValue.budget = this.progetto_model.budget
        this.sottoprogettoDefaultValue.data_inizio = this.progetto_model.data_inizio
        this.sottoprogettoDefaultValue.data_fine = this.progetto_model.data_fine
        this.sottoprogettoDefaultValue.anno = moment(this.progetto_model.data_inizio).year()
        this.sottoprogettoDefaultValue.azienda_gruppo_id = this.progetto_model.azienda_gruppo_id

    }

    sottoProgettiCols = [
        {
            name: 'Codice commessa',
            prop: 'cod_nodo',
            orderable: true,
            class: 'text-left w-40 whitespace-nowrap',
            td_class: 'px-2 h-11.5 bg-next-gray-md-dark',
            resizable: false
        },
        {
            name: 'Titolo sottoprogetto',
            prop: 'titolo',
            orderable: true,
            class: 'text-left min-w-285 whitespace-nowrap',
            td_class: 'px-2 h-11.5 bg-next-gray-md-dark',
            resizable: false
        },
        {
            name: 'BU',
            prop: 'business_unit_id',
            orderable: true,
            class: 'text-left w-12 whitespace-nowrap',
            td_class: 'px-2 h-11.5 bg-next-gray-md-dark',
            resizable: false
        },
        {
            name: 'Data inizio',
            prop: 'data_inizio',
            orderable: true,
            class: 'text-left min-w-110 w-28 whitespace-nowrap',
            td_class: 'px-2 bg-next-gray-md-dark',
            resizable: false
        },
        {
            name: 'Data fine',
            prop: 'data_fine',
            orderable: true,
            class: 'text-left min-w-110 w-28 whitespace-nowrap',
            td_class: 'px-2 bg-next-gray-md-dark',
            resizable: false
        },
        {
            name: 'Budget aper.',
            prop: 'budget',
            orderable: true,
            class: 'text-left min-w-110 w-32 whitespace-nowrap',
            td_class: 'text-right px-2 bg-next-gray-md-dark',
            resizable: false
        },
        {
            name: 'Stato',
            prop: 'stato',
            orderable: true,
            class: 'text-left min-w-110 w-32 whitespace-nowrap',
            td_class: 'text-right px-2 bg-next-gray-md-dark',
            resizable: false
        },
        {
            name: '',
            orderable: false,
            class: 'min-w-10 w-10 whitespace-nowrap',
            td_class: 'relative hover:bg-next-orange hover:text-white bg-next-gray-md-dark',
            resizable: false
        },
        // {
        //     name: '',
        //     orderable: false,
        //     class: 'min-w-10 w-10 whitespace-nowrap',
        //     td_class: 'relative hover:bg-next-orange hover:text-white bg-next-gray-md-dark',
        //     resizable: false
        // }
    ]
}


</script>


<style lang="scss">

</style>
